import {Button, Col, Row} from "react-bootstrap";
import Select from "react-select";
import NumberFormat from "react-number-format";
import {useMemo, useState} from "react";
import {useFormikContext} from "formik";
import notyfApi from "../../../../utils/notyfApi";

// Tool which helps to calculate a different margin based on price or margin.
const CalculateTool = ({totals}) => {
    const {values, setFieldValue} = useFormikContext(); // Get the values from the formik context.

    const {service_form_project_hours_cost, service_form_project_hour_tariffs} = values

    const calculateOptions = useMemo(() =>[
        {value: 'boa', label: 'BOA'},
        {value: 'oh', label: 'OH'},
        {value: 'pl', label: 'PL'},
    ],[]) // Options for the select field.

    const [cat, setCat] = useState(null) // Category selected
    const [cost, setCost] = useState(null) // Price selected
    const [margin, setMargin] = useState(null) // Margin selected

    const handleCalculation = (marginBool) => {
        if (!cat) return notyfApi.error("Geen categorie geselecteerd") // Check if a category is selected.
        if (!cost && !marginBool) return notyfApi.error("Geen Prijs ingevuld") // Check if a price is filled in.
        if (!margin && marginBool) return notyfApi.error("Geen Marge ingevuld") // Check if a margin is filled in.

        const tariffs = {...service_form_project_hour_tariffs} // Copy the tariffs from the formik context.
        let diff
        if (marginBool) {
            let newCost = (totals.cost + totals.risc) / (1 - margin / 100) // Calculate the new cost.
            diff = newCost - totals.sale // Calculate the difference.
        } else {
            diff = cost - totals.sale // Calculate the difference.

        }
        if (cat === "boa" && (service_form_project_hours_cost.boaBasis || service_form_project_hours_cost.boa || service_form_project_hours_cost.energy)) {
            let newTargetCost = (service_form_project_hours_cost.boaBasis || 0)
            newTargetCost += (service_form_project_hours_cost.boa || 0)
            newTargetCost += (service_form_project_hours_cost.energy || 0)

            let newTargetSale = (service_form_project_hours_cost.boaBasis / (1 - service_form_project_hour_tariffs.boa.margin) || 0)
            newTargetSale += (service_form_project_hours_cost.boa / (1 - service_form_project_hour_tariffs.boa.margin) || 0)
            newTargetSale += (service_form_project_hours_cost.energy / (1 - service_form_project_hour_tariffs.boa.margin) || 0)
            newTargetSale += diff

            const newMargin = parseFloat((newTargetSale - newTargetCost) / newTargetSale);
            if (newMargin < 0 || newMargin >= 1) return notyfApi.error("Te weinig marge. De marge mag niet onder de 0% of boven de 100% komen")
            tariffs.boa.margin = newMargin
        } else if (cat === "oh" && (service_form_project_hours_cost.ohddc || service_form_project_hours_cost.ohveld)) {
            let newTargetCost = (service_form_project_hours_cost.ohddc || 0)
            newTargetCost += (service_form_project_hours_cost.ohveld || 0)
            let newTargetSale = (service_form_project_hours_cost.ohddc / (1 - service_form_project_hour_tariffs.oh.margin) || 0)
            newTargetSale += (service_form_project_hours_cost.ohveld / (1 - service_form_project_hour_tariffs.oh.margin) || 0)
            newTargetSale += diff
            const newMargin = parseFloat((newTargetSale - newTargetCost) / newTargetSale);
            if (newMargin < 0 || newMargin >= 1) return notyfApi.error("Te weinig marge. De marge mag niet onder de 0% of boven de 100% komen")
            tariffs.oh.margin = newMargin
        } else if (cat === "pl" && service_form_project_hours_cost.pl) {
            const newTargetSale = ((service_form_project_hours_cost.pl / (1 - service_form_project_hour_tariffs.pl.margin)) + diff)
            const newMargin = parseFloat((newTargetSale - service_form_project_hours_cost.pl) / newTargetSale);
            if (newMargin < 0 || newMargin >= 1) return notyfApi.error("Te weinig marge. De marge mag niet onder de 0 of boven de 1 komen")
            tariffs.pl.margin = newMargin
        } else {
            return notyfApi.error("Geen Kost ingevuld")
        }

        setFieldValue("service_form_project_hour_tariffs", tariffs)
    }
    return <>     <Row className={"mb-1"}>
        <Col></Col>

        <Col>
            <Select
                menuPlacement={"top"}
                options={calculateOptions}
                onChange={e => setCat(e.value)}
                placeholder={<div>Selecteer een categorie</div>}
            />
        </Col>
        <Col>
            <NumberFormat className={"form-control h-100"}
                          value={cost}
                          onValueChange={event => setCost(event.floatValue)}
                          displayType={'number'}
                          thousandSeparator={true}
                          placeholder="Prijs"
                          allowNegative={false}
                          prefix={'€'}/>

        </Col>
        <Col>
            <NumberFormat className={"form-control h-100"}
                          value={margin}
                          onValueChange={event => setMargin(event.floatValue)}
                          displayType={'number'}
                          placeholder="Marge"
                          allowNegative={false}
                          suffix={'%'}/>
        </Col>
    </Row>
        <Row className={"mb-1"}>
            <Col></Col>
            <Col></Col>
            <Col className={'d-flex justify-content-center'}>
                <Button className={'btn-regelapp'}
                        onClick={() => handleCalculation(false)}
                >Prijs</Button>
            </Col>
            <Col className={'d-flex justify-content-center'}>
                <Button className={'btn-regelapp'}
                        onClick={() => handleCalculation(true)}
                >
                    Marge
                </Button>
            </Col>
        </Row>
        <Row className={"mb-1"}>


        </Row>
    </>
}
export default CalculateTool